import { Card, Heading, Stack } from '@backyard-ui/core';

import { Image } from '@/presenters/components/common/Image';

import { styles } from './Item.styles';

interface ItemProps {
  title: string;
  src?: string;
  testId: string;
}

export default function Item(props: Readonly<ItemProps>) {
  const { title, src, testId } = props;

  const classNames = styles();

  return (
    <Card.Root
      direction="row"
      UNSAFE_className={classNames.wrapper()}
      data-testid={testId}
    >
      <Stack className={classNames.content()} align="center" spacing="1">
        {src && (
          <div className={classNames.image()}>
            <Image height={48} width={48} alt={title} src={src} />
          </div>
        )}

        <Card.Body>
          <Stack direction="column" spacing="1">
            <Heading size="sm" asChild>
              <div role="heading" aria-level={1}>
                {title}
              </div>
            </Heading>
          </Stack>
        </Card.Body>
      </Stack>
    </Card.Root>
  );
}
